import FJInput from '../common/FJInput/FJInput';
import { useCallback, useEffect, useRef, useState } from 'react';
import FJButton from '../common/FJButton/FJButton';
import Style from './SetPassword.module.less';
import FJNav from '../common/FJNav/FJNav';
import FJLocalStore from '../../store/FJLocalStore';
import classNames from 'classnames';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';
import { useSelector } from 'react-redux';

const SetPassword = props => {
    useLocalStore();
    let { email, stepChange, password, passwordChange, emailRegister, popupType, active, page, method } = props;
    // const [password, setPassword] = useState('')
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    let inputRef = useRef();
    let _passwordChange = curValue => {
        _clean();
        passwordChange(curValue);
        // setPassword(curValue)
    };
    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };
    let _navClick = () => {
        passwordChange('');
        stepChange('default');
    };
    let _formatCheck = useCallback(() => {
        let res = true;
        if (password.trim() !== password) {
            inputRef.current.setErrorMessage(FJLocalStore._('password-without-blank-space'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        // password-without-blank-space
        if (password.length === 0) {
            inputRef.current.setErrorMessage(FJLocalStore._('enter-password-here'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        if (password.length < 9) {
            inputRef.current.setErrorMessage(FJLocalStore._('password-least-nine-character'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        return res;
    }, [password]);

    let _singUp = useCallback(() => {
        let res = _formatCheck();
        if (!res) {
            const origin = method === 'single' ? page : window.location.pathname;
            FJUtil.ealog('sign up error', {
                'error reason': 'Invalid password',
                'error mode': 'email',
                'error page': 'page_' + origin,
                'error account': email,
            });
            return;
        }
        setLoad(true);
        emailRegister(password, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
                // setPassword('')
            } else if (option.type === 'clean') {
                setErrTip(null);
                // setPassword('')
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [password, _formatCheck, emailRegister]);

    let _enterRegister = useCallback(
        event => {
            if (event.keyCode === 13) {
                _singUp();
            }
        },
        [_singUp],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterRegister);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterRegister);
        };
    }, [_enterRegister]);

    const { step } = useSelector(store => {
        return {
            step: store.mainStore.step,
        };
    });
    return (
        <div
            id='registerBox'
            className={classNames(Style.register_box, {
                [Style.register_box_show]: active,
                [Style.register_box_popup]: popupType,
            })}
        >
            <FJNav title={FJLocalStore._('set-password-here')} onClick={_navClick} popupType={popupType} />
            {/* 特殊处理 */}
            <div style={{ userSelect: 'none' }}>
                <input defaultValue={email} autoComplete='UserName' type='text' style={{ width: '1px', opacity: 0 }} />
                <input type='text' style={{ width: '1px', height: '54px', opacity: 0 }} />
            </div>
            <p
                className={Style.curTip}
                dangerouslySetInnerHTML={{ __html: FJLocalStore._('set-password-to-continue') }}
            />
            {/*<input readOnly={true} type='password' autoComplete="new-password"  style={{height:'0px'}}/>*/}
            <FJInput
                value={password}
                onChange={_passwordChange}
                label={FJLocalStore._('password')}
                placeholder={FJLocalStore._('enter-password-here')}
                type='password'
                hasRightIcon
                style={{ marginTop: '39px' }}
                className={Style.inputMargin}
                inputClassName={Style.input}
                iconClassName={Style.inputRightIcon}
                ref={inputRef}
                popupType={popupType}
                preventAutoComplete
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('sign-up')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_singUp}
            />
            <div
                className='g-recaptcha'
                style={{ display: 'flex', justifyContent: 'center', padding: '20px 0 0 0' }}
                id='register-recaptcha'
            />
        </div>
    );
};
export default SetPassword;
